<script lang="ts" setup>
import type { ComponentLayoutSimpleHeader } from '@autobid/strapi-integration/graphql/graphql'

interface Props {
  data: ComponentLayoutSimpleHeader
}

defineProps<Props>()
</script>

<template>
  <div class="flex w-full items-center justify-between">
    <div class="flex items-center text-lg lg:text-2xl xl:text-4xl">
      <CommonIcon
        v-if="data.icon"
        class="mr-1.5 text-3xl lg:text-5xl"
        :name="data.icon"
      />
      <span>{{ data.title }}</span>
    </div>
    <div>
      <template v-for="img in data.logos">
        <component
          :is="img.url?.length ? 'a' : 'span'"
          v-if="img"
          :key="img.id"
          v-bind="img.url?.length ? { href: img.url } : {}"
        >
          <CommonStrapiImage
            :data="img.image"
            class="max-h-[50px] w-auto"
          />
        </component>
      </template>
    </div>
  </div>
</template>
